<template>
    <li class="layer group">
        <div class="row">
            <button class="caret" :class="{ rotated: isOpen }" title="Toggle" @click.stop="toggle">▾</button>
            <!-- <span class="caret placeholder"></span> -->
            <span class="thumb board">Gr</span>
            <span class="label">New Group</span>
            <span class="meta">3200 × 2200</span>
        </div>
        <transition name="collapse">
        <ul v-show="isOpen" class="children" ref="children">
            <RectComp :selected="false" />
            <TextComp :selected="false" />
            <VectorComp :selected="false" />
            <FrameComp :selected="false" />
        </ul>
        </transition>
    </li>
</template>

<script>
import RectComp from './ImageComp.vue';
import TextComp from './TextComp.vue';
import VectorComp from './VectorComp.vue';
import FrameComp from './FrameComp.vue';

export default {
    name: 'LayerComp',
    components: {
        RectComp,
        TextComp,
        VectorComp,
        FrameComp
    },
    data(){
        return {
            isOpen: true,
            selected: {
                fill: '#ffffff'
            }
        }
    },
    props: {
        children: []
    },
    mounted(){
        this.updateAutoHeight();
    },
    updated(){
        this.updateAutoHeight();
    },
    methods: {
        toggle(){
            this.isOpen = !this.isOpen;
        },
        updateAutoHeight(){
            const el = this.$refs.children;
            if(!el) return;
            el.style.setProperty('--auto-height', el.scrollHeight + 'px');
        }
    }
}
</script>

<style scoped>
.layer .row { display: grid; grid-template-columns: 16px 20px 1fr auto; align-items: center; gap: 8px; padding: 6px 8px; border: 1px solid var(--border); background: var(--panel); border-radius: 6px; }
.layer.group .row { background: var(--panel-2); }
.layer.selected .row { border-color: var(--accent, #5b8cff); background: var(--panel-selected); }
.layers { list-style: none; margin: 0; padding: 0; display: grid; gap: 4px; }
.layer { border-radius: 6px; }
.caret { width: 16px; text-align: center; color: var(--muted); transition: transform 160ms ease; display: inline-block; background: transparent; border: 0; padding: 0; cursor: pointer; font: inherit; }
.caret.rotated { transform: rotate(-90deg); }
.caret.placeholder { color: transparent; }
.thumb { width: 20px; height: 20px; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center; font-size: 11px; color: var(--muted); border: 1px solid var(--border); background: var(--panel-2, #1c2738); }
.thumb.board { border-style: dashed; }
.thumb.color { border: 1px solid var(--border); background: #ffffff; }
.thumb.text { font-weight: 700; }
.label { color: var(--text); font-size: 12px; }
.meta { color: var(--muted); font-size: 11px; }
.children { list-style: none; margin: 4px 0 0 20px; padding: 0; display: grid; gap: 4px; }

/* Collapse transition: smoothly animate height + opacity */
.collapse-enter-active,
.collapse-leave-active { transition: height 180ms ease, opacity 160ms ease; overflow: hidden; }
.collapse-enter-from,
.collapse-leave-to { height: 0; opacity: 0; }
.collapse-enter-to,
.collapse-leave-from { height: var(--auto-height); opacity: 1; }

/* Utility to compute auto height via CSS variable set on mount/update */
</style>
